
const css = ".styles-module__tooltip___mcXL2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: help;\n}\n\n.styles-module__tooltipIcon___Nq2nD {\n  transform: translateY(0.5px);\n  color: #fff;\n  opacity: 0.2;\n  transition: opacity 0.15s ease;\n  will-change: transform;\n}\n.styles-module__tooltip___mcXL2:hover .styles-module__tooltipIcon___Nq2nD {\n  opacity: 0.5;\n}\n[data-agentation-theme=light] .styles-module__tooltipIcon___Nq2nD {\n  color: #000;\n}";
const classNames = {"tooltip":"styles-module__tooltip___mcXL2","tooltipIcon":"styles-module__tooltipIcon___Nq2nD"};

// SSR-safe style injection (always update for HMR)
if (typeof document !== 'undefined') {
  let style = document.getElementById('feedback-tool-styles-help-tooltip-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'feedback-tool-styles-help-tooltip-styles';
    document.head.appendChild(style);
  }
  style.textContent = css;
}

export default classNames;
